import { Gift } from "../../components/layout/Gift/Gift";
import Header from "../../components/layout/Header/Header";
import Layout from "../../components/layout/Layout/Layout";


export default function SubscriptionPage() {
  return (
    <Layout>
      <Header/>
      <Gift/>
    </Layout>
  );
}
